<template>
    <div :class="$style.wrapper">
        <component
            :is="props.link?.name ? BaseLink : 'div'"
            :to="props.link"
            :class="[$style.title, props.link?.name ? '' : $style.title_without_link]"
        >
            <!--  we need this div, it’s a safeguard against an empty icon, otherwise, the grid breaks -->
            <div :class="$style.icon_wrapper">
                <Icon
                    v-if="icon"
                    :name="icon"
                    :class="[$style.icon, $style[`icon_${categoryId}` as keyof typeof $style]]"
                />
            </div>
            <Typography
                is="h3"
                type="label"
                size="l"
                :bold="true"
                :responsive="false"
            >
                {{ props.title }}
            </Typography>
            <Typography
                v-if="props.link?.name"
                type="label"
                size="xs"
                :responsive="false"
                :class="$style.subtitle"
            >
                {{ $tr('category.show_all_games') }}
            </Typography>
        </component>
        <Button
            v-if="categoryId === 'new'"
            interfaceTarget="add-game-promo"
            :externalTo="DEVELOPERS_LANDPAGE_PATH"
            color="salad"
            :label="$tr('homePage.addMyGame')"
        />
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { RouteLocationNamedRaw } from 'vue-router'

import BaseLink from '@/components/BaseLink.vue'
import Button from '@/components/Buttons/Button.vue'
import { IconNameType, icons } from '@/components/Icon'
import Icon from '@/components/Icon/Icon.vue'
import Typography from '@/components/Typography.vue'
import { DEVELOPERS_LANDPAGE_PATH } from '@/router/navigation-constants'

const props = defineProps<{
    link?: RouteLocationNamedRaw
    title?: string
    categoryId: IconNameType
}>()

const icon = computed(() => {
    if (!props.categoryId || props.categoryId.includes('placeholder')) {
        return undefined //we need undefined to show nothing instead of 'funny' icon before data arrives
    }
    return icons[props.categoryId] ? props.categoryId : 'funny' //fallback if no icon
})
</script>

<style module>
.wrapper {
    display: flex;
    justify-content: space-between;
    margin-bottom: 13px;
}

.title {
    display: grid;
    grid-template-columns: 32px 1fr;
    grid-template-rows: 18px auto;
    column-gap: 8px;
    row-gap: 2px;
    width: fit-content;
}

.icon_wrapper {
    grid-row: span 2;
}

.title_without_link {
    grid-template-rows: auto;
    align-items: center;
}

.title_without_link .icon_wrapper {
    grid-row: span 1;
}

.icon {
    width: 32px;
    height: 32px;
    color: #fff;
}

.icon_obby {
    color: #ffde26;
}

.subtitle {
    color: rgba(255, 255, 255, 0.56);
}

.title:hover .subtitle {
    color: #fff;
}
</style>
